<template>
  <div>
    <section class="store">
      <div class="store__header">
        <div class="store__header__content">
          <h1>{{ getTranslations.home_store_store }}</h1>
        </div>
      </div>
      <div class="store__content">
        <div class="store__content__head">
          <h2>{{ getTranslations.home_store_buy_games }}</h2>
        </div>
        <div :class="['store__content__list ', storedBundles.length > 0 ? '' : ' store_empty' ]">
         <span class="empty_msg">{{ getTranslations.home_store_no_bundles }}</span>
          <ul>
            <li v-for="(storeItem, index) in orderedStoreItems" :key="index">
              <div v-if="storeItem.jokers === 1" class="jokers_outer">
                <span class="boldspan">{{ getTranslations.home_store_surprise_joker }}</span><br><span class="joker">{{ getTranslations.home_store_need_more_jokers }} </span>
              </div>
              <div v-else-if="storeItem.jokers === 3" class="jokers_outer">
                <span class="boldspan">{{ getTranslations.home_store_magic_joker }}
              </span><br><span class="joker">{{ getTranslations.home_store_purchase_jokers }}
              </span>
              </div>
              <div v-else><span class="boldspan">{{ storeItem.noOfGames?storeItem.noOfGames +' '+ getTranslations.home_store_games :'' }}
               {{storeItem.noOfGames && storeItem.points?getTranslations.home_store_and :''}}
               {{storeItem.points?storeItem.points +' '+ getTranslations.home_store_points:''}}
               {{ getTranslations.home_store_for }}</span><span> {{ storeItem.price
                }} {{ storeItem.currencyCode }}</span>
              </div>
              <a style="cursor:pointer"
                 class="btn2 btn2--std btn2--small btn2--green"
                 @click.prevent="getIt(storeItem.bundleId, storeItem.noOfGames, storeItem.price, storeItem.currencyCode, storeItem.points, storeItem.jokers > 0, storeItem.jokers)">
                {{ getTranslations.home_store_get_it }}
              </a>
            </li>
            <li v-if="inviteConfig.inviteEnable && fbInviteEnable()" class="boldspan">
              <div>
                <span class="boldspan">1 {{ getTranslations.home_store_game}} {{ getTranslations.home_store_for }} </span>
                <span>{{ getTranslations.home_store_suc_friend }}</span>
              </div>
              <a class="btn2 btn2--std btn2--small btn2--green"
                 @click.prevent="shareFriendsInvitation()"
                 style="cursor:pointer">
                {{ getTranslations.home_store_invite }}
              </a>
            </li>
          </ul>
          <span v-if="vatBanner" class="store_note">{{ getTranslations.home_store_vat }}</span>
        </div>
      </div>
      <!-- dynamically change modals -->
      <fade-transition>
        <component :is="modalForStore"
                   @close="storeModalForStore(null)"
                   @bundlePurchase="bundlePurchase">
        </component>
      </fade-transition>
    </section>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */

import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ConfirmPurchase from './modals/ConfirmPurchase';
import ConfirmPurchaseForPin from './modals/ConfirmPurchaseForPin';
import ConfirmPurchaseForPinError from './modals/ConfirmPurchaseForPinError';
import ConfirmPurchaseViaSms from './modals/ConfirmPurchaseViaSms';
import InviteFriend from './modals/users/InviteFriend';

export default {
  name: 'store',
  components: {
    FadeTransition,
  },
  mounted() {
    // init google analytics (from the imported mixin)
    this.storedBundlesCall();
    // this.gameInfo = this.gameCardDTOS.slice(0).sort((a, b) => a.mwDisplayIndex - b.mwDisplayIndex);
  },
  methods: {
    ...mapActions('profile', [
      'requestPin',
      'storedBundlesCall',
      'getUserLoginDetails',
    ]),
    ...mapMutations('profile', [
      'setBundleId',
      'setBundleData',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    fbInviteEnable() {
      // eslint-disable-next-line
      //this.getIntegrationConfig.config.inviteFBenable not used anymore
      return this.facebookFunctionality;
    },
    bundlePurchase() {
      this.getUserLoginDetails();
    },
    shareFriendsInvitation() {
      this.storeModalForStore(InviteFriend);
    },
    getIt(bundleId, numberOfGames1, price1, currencyCode1, points1, joker1, numOfJokers1) {
      this.getUserLoginDetails().then(() => {
        if (this.purchaseBundleFromUnsubUser) {
          this.getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1, joker1, numOfJokers1);
        } else {
          // eslint-disable-next-line
          if (!this.userDetails.subscribed) {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForStore(ResubscribeGameSms);
              } else {
                this.storeModalForStore(ResubscribeGame);
              }
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
          } else {
            this.getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1, joker1, numOfJokers1);
          }
        }
      });
    },
    getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1, joker1, numOfJokers1) {
      this.setBundleId(bundleId);
      const bundleData = {
        numberOfGames: numberOfGames1,
        price: price1,
        currencyCode: currencyCode1,
        points: points1,
        joker: joker1,
        numOfJokers: numOfJokers1,
      };
      this.setBundleData({ bundleDataObject: bundleData });
      if (this.purchaseViaSMS) {
        if (this.smsAutomaticResponse) {
          let phoneNumber, message;
          if (bundleData.numOfJokers === 1) {
            phoneNumber = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_surprise_joker_sortcode');
            message = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_surprise_joker_keyword');
          } else if (bundleData.numOfJokers === 3) {
            phoneNumber = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_magic_joker_sortcode');
            message = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_magic_joker_keyword');
          } else {
            phoneNumber = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_sortcode');
            message = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal,'home_store_keyword');
          }
          console.log(message);
          console.log(phoneNumber);
          let smsLink;
          if (this.isAndroid()) {
            smsLink = `sms:${phoneNumber}?body=${message}`;
            window.location.href = smsLink;
          } else if (this.isiOS()) {
            smsLink = `sms:${phoneNumber}&body=${message}`;
            window.location.href = smsLink;
          } else {
            this.storeModalForStore(ConfirmPurchaseViaSms);
            this.showModal();
          }
        } else {
          this.storeModalForStore(ConfirmPurchaseViaSms);
        }
        // this.storeModalForStore(ConfirmPurchaseViaSms);
      } else {
        // eslint-disable-next-line
        if (this.pinForBundles) {
          const bundleInfo = {
            bundleId: this.bundleId,
          };
          this.requestPin({ value: bundleInfo }).then(() => {
            if (this.requestPinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseForPin);
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
            }
          });
        } else {
          this.storeModalForStore(ConfirmPurchase);
        }
      }
    },
    isAndroid() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android/i.test(userAgent);
    },
    isiOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    },
  },
  computed: {
    ...mapState('common', [
      'inviteConfig',
      'multiOperatorInfo',
      'smsAutomaticResponse',
      'purchaseBundleFromUnsubUser',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'pinForBundles',
      'purchaseViaSMS',
      'modalForStore',
      'userDetails',
      'vatBanner',
      'facebookFunctionality',
    ]),
    ...mapState('profile', [
      'storedBundles',
      'requestPinResponse',
      'bundleId',
      'grandPrize',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    orderedStoreItems() {
      // sort items by date ascending
      return this.storedBundles.slice(0).sort((a, b) => a.price - b.price).sort((a, b) => a.jokers - b.jokers);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/Store.vue